import React from 'react'
import PropTypes from 'prop-types'

const AddDomainResourceButton = (props) => (
	<button className="AddDomainResourceButton" onClick={props.click}><span>{props.text}</span></button>
)

AddDomainResourceButton.propTypes = {
	click: PropTypes.func,
	text: PropTypes.string.isRequired
}

export default AddDomainResourceButton


// WEBPACK FOOTER //
// ./src/components/AddDomainResourceControl/AddDomainResourceButton.js